import { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { AuthCallback, SilentAuthCallback } from "./modules/auth/components/AuthCallback";
import { PrivateRoute } from "./modules/auth/components/PrivateRoute";
import { AdminRoute } from "./modules/auth/components/AdminRoute";
import { MonitoringRoute } from "./modules/auth/components/MonitoringRoute";
import Accounts from "./modules/account/screens/Accounts";
import BillingAlertFailures from "./modules/monitoring/screens/BillingAlertFailures";
import Page404 from "./modules/_core/screens/Page404";
import ScrollToTop from "./modules/_core/providers/ScrollToTop";
import Alerts from "./modules/_core/providers/Alerts";
import UILoader from "./modules/_core/components/ui/UILoader";
import Logout from "./modules/auth/screens/Logout";
import NoUser from "./modules/_core/screens/NoUser";
import Providers from "./modules/_core/providers";
import { setupAuth } from "./modules/auth/utils";
import Login from "./modules/auth/screens/Login";
import AddUser from "./modules/users/screens/AddUser";
import Users from "./modules/users/screens/Users";
import PartnerUsers from "./modules/partner-users/screens/PartnerUsers";
import AuthFeedback from "./modules/auth/screens/AuthFeedback";
import ResetPassword from "./modules/auth/screens/ResetPassword";

const App = () => {
  const [isReady, setIsReady] = useState(false);
  useEffect(() => {
    (async () => {
      try {
        await setupAuth();
        setIsReady(true);
      } catch (e) {
        console.error(e);
      }
    })();
  }, []);
  if (!isReady) return <UILoader overlay />;
  return (
    <Providers>
      <AppRoutes />
    </Providers>
  );
};

function AppRoutes() {
  return (
    <Router>
      <Alerts />
      <ScrollToTop />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/login/invite" element={<Login />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/auth/feedback" element={<AuthFeedback />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/no-user" element={<NoUser />} />
        <Route path="/oauth_callback" element={<AuthCallback />} />
        <Route path="/silent_oauth_callback" element={<SilentAuthCallback />} />

        <Route
          path="/customer-users"
          element={
            <PrivateRoute>
              <Users />
            </PrivateRoute>
          }
        />
        <Route
          path="/customer-users/new"
          element={
            <PrivateRoute>
              <AddUser />
            </PrivateRoute>
          }
        />
        <Route
          path="/partner-users"
          element={
            <PrivateRoute>
              <AdminRoute>
                <PartnerUsers />
              </AdminRoute>
            </PrivateRoute>
          }
        />
        <Route
          path="/monitoring/billing-alert-failures"
          element={
            <PrivateRoute>
              <MonitoringRoute>
                <BillingAlertFailures />
              </MonitoringRoute>
            </PrivateRoute>
          }
        />
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Accounts />
            </PrivateRoute>
          }
        />
        <Route path="*" element={<Page404 />} />
      </Routes>
    </Router>
  );
}

export default App;
